'use client';

import DiscountCodeCard from '@/components/store/DiscountCodeCard';
import VendorList from '@/components/store/VendorList';
import { Store } from '@/lib/types/customer/restaurant/StoreProfile';
import PhoneVerificationModal from '@/components/account/profile/PhoneVerificationModal';
import { useState } from 'react';
import { useUserStore } from '@/stores/customer/user';
import { storage_keys } from '@/constant/configs';
import VerifyPhoneAlert from './VerifyPhoneAlert';

interface DiscountCodeVendorListProps {
  store: Store;
  userToken?: string | null;
}

function DiscountCodeVendorList({
  store,
  userToken,
}: DiscountCodeVendorListProps) {
  const user = useUserStore((state) => state.user);
  const isDisabled = !!user && !user.phone_verified;
  const hasAuthToken =
    !!userToken ||
    (typeof window !== 'undefined' &&
      !!localStorage.getItem(storage_keys.customer_token));
  const isUserLoading = user === null && hasAuthToken;

  const [showPhoneVerifyModal, setShowPhoneVerifyModal] = useState(false);

  const handleOpenPhoneVerifyModal = () => {
    setShowPhoneVerifyModal(true);
  };

  const handleClosePhoneVerifyModal = () => {
    setShowPhoneVerifyModal(false);
  };

  const handlePhoneVerified = () => {
    // Refresh user data or update local state
    window.location.reload();
  };

  return (
    <>
      {
        // store.restaurant_config.links?.online_shop &&
        <VerifyPhoneAlert
          handleOpenPhoneVerifyModal={handleOpenPhoneVerifyModal}
          isDisabled={isDisabled}
          isLoading={isUserLoading}
        />
      }
      {store.discount_codes && store.discount_codes?.length > 0 && (
        <div className="mt-12 flex flex-col gap-4">
          {store.discount_codes.map((discountCode) => (
            <DiscountCodeCard
              key={discountCode.id}
              data={discountCode}
              storeName={store.name}
              storeLogo={store.media?.logo?.[0]?.url}
              onlineShopLink={store.restaurant_config.links?.online_shop || ''}
              handleOpenPhoneVerifyModal={handleOpenPhoneVerifyModal}
              isDisabled={isDisabled}
            />
          ))}
        </div>
      )}
      <VendorList
        store={store}
        links={store.restaurant_config.links}
        activeSubscription={store.active_subscription}
        isDisabled={isDisabled}
      />
      <PhoneVerificationModal
        isOpen={showPhoneVerifyModal}
        onClose={handleClosePhoneVerifyModal}
        userPhone={user?.phone}
        phoneVerified={user?.phone_verified}
        onVerified={handlePhoneVerified}
      />
    </>
  );
}

export default DiscountCodeVendorList;
